<template>
  <div>
    <v-tooltip v-if="!isActivePopover" color="grey-background" right transition="scale-transition" :max-width="300" :open-on-hover="isTooltip && !!activeStatus.detail && activeStatus.detail !== activeStatus.summary">
      <template v-slot:activator="{on}">
        <v-chip v-if="activeStatus" v-on="isTooltip && activeStatus.detail && activeStatus.detail !== activeStatus.summary ? on : false" :color="activeStatus.color" small label :class="[{'px-2' : activeShortMode.includes($route.name)}, {'chip-status-no-truncate': noTruncate}]">
            <span class="font-weight-semibold" :class="noTruncate ? 'chip-status-text-wrap' : 'd-inline-block text-truncate'" :style="noTruncate ? '' : 'max-width: 150px;'" v-if="routeList.includes($route.name) || showDetail || customText">
              <template v-if="customText">
                <span>{{ customText }}</span>
              </template>
              <template v-else-if="['DocumentsList', 'SummariesList', 'SummariesRetrieve', 'PurchaseList', 'DocumentsRetrieve', 'DocumentsBatchRetrieve', 'PurchaseRetrieve'].includes($route.name)">
              <span>{{ $route.name === 'DocumentsRetrieve' ? activeStatus.detail : `${activeStatus.summary} ${activeStatus.id === 'OBS' ? 'con reparo' : ''}` }}</span>
            </template>
            </span>
          <v-icon :right="!activeShortMode.includes($route.name)">{{activeStatus.icon}}</v-icon>
        </v-chip>
      </template>
      <div>
        <span class="d-block px-3 py-2" v-if="detail" v-html="detail"></span>
        <span class="d-block px-3 py-2" v-else-if="(activeStatus || {}).detail === 'Enviado a SII'">{{ $t('generals.Enviado a SII') }}</span>
        <span class="d-block px-3 py-2" v-else-if="!['PurchaseList','PurchaseRetrieve'].includes($route.name)">{{activeStatus.detail}}</span>
      </div>
    </v-tooltip>
    <v-menu class="list-active-draw" v-else-if="activeStatus?.id" right :close-delay="100" :open-on-click="false" :open-on-hover="!
    !detail" :open-delay="10" :nudge-right="20" offset-x max-width="300">
      <template v-slot:activator="{ on, attrs }">
        <v-chip v-bind="attrs" v-on="detail !== activeStatus.summary ? on : false" :color="activeStatus.color" small label :class="{'px-2' : activeShortMode.includes($route.name)}">
          <span class="d-inline-block text-truncate" style="max-width: 150px;" v-if="routeList.includes($route.name) || showDetail">
            <template v-if="['DocumentsList', 'SummariesList', 'SummariesRetrieve', 'PurchaseList', 'DocumentsRetrieve', 'DocumentsBatchRetrieve', 'PurchaseRetrieve'].includes($route.name)">
            <span class="font-weight-semibold">{{ $route.name === 'DocumentsRetrieve' ? activeStatus.detail : `${activeStatus.summary} ${activeStatus.id === 'OBS' ? 'con reparo' : ''}` }}</span>
          </template>
          </span>
          <v-icon :right="!activeShortMode.includes($route.name)">{{activeStatus.icon}}</v-icon>
        </v-chip>
      </template>
      <v-list class="pa-0">
        <span class="d-block caption px-3" style="line-height: 1.2" v-if="detail" v-html="detail || activeStatus.detail"></span>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
import documentStatuses from '@/collections/documentStatuses'
import purchaseStatuses from '@/collections/purchaseStatuses'
import summariesStatuses from '@/collections/summariesStatuses'
import assignStatuses from '@/collections/assignStatuses'

export default {
  props: {
    status: {
      type: null,
      required: true
    },
    isTooltip: {
      type: Boolean,
      deault: false
    },
    showDetail: {
      type: Boolean,
      deault: false
    },
    detail: {
      type: null
    },
    isActivePopover: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    customText: {
      type: String,
      default: ''
    },
    noTruncate: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    activeShortMode: ['BranchRetrieveUpdate', 'PosRetrieveUpdate', 'SupplierRetrieveUpdate', 'CustomerRetrieveUpdate'],
    documentsStatuses: documentStatuses,
    purchasesStatuses: purchaseStatuses,
    summariesStatuses: summariesStatuses,
    assignStatuses: assignStatuses,
    routeList: ['DocumentsList', 'SummariesList', 'SummariesRetrieve', 'PurchaseList', 'DocumentsBatchRetrieve', 'DocumentsBatchListCreate', 'PurchaseRetrieve']
  }),
  computed: {
    activeStatus () {
      return this.currentStatusesList().find(s => s.id === this.status) ?? this.status
    }
  },
  mounted () {
    this.currentStatusesList()
  },
  methods: {
    currentStatusesList () {
      return this[`${this.type}Statuses`] ?? []
    }
  }
}
</script>
<style>
.chip-status-no-truncate {
  height: auto !important;
  min-height: 24px !important;
  padding-top: 2px !important;
  padding-bottom: 2px !important;
}
.chip-status-no-truncate .v-chip__content {
  white-space: normal !important;
  word-break: break-word;
  align-items: center;
}
.chip-status-text-wrap {
  white-space: normal !important;
  word-break: break-word;
  max-width: none !important;
}
</style>